import React from "react";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { useFormContext } from "react-hook-form";

import { HubBackButton, HubButton } from "../../components";
import { useGetBarcode, useHubSnackBar } from "../../hooks";

import BarcodeContextMenu from "./BarcodeContextMenu";
import { StyledInput, StyledTitleStack } from "./styles";
import { handleDownloadZplHelper } from "./helper";

const BarcodeBuilderBar = ({
  batch = true,
  name = "",
  data = {},
  disabled = false,
}) => {
  const { id } = useParams();
  const passId = !!Number(id);

  const { getValues } = useFormContext();
  const { data: barcode } = useGetBarcode(passId && id);

  const isExisting = barcode?.id;
  const labelType = batch ? "Batch" : "Template";
  const postType = isExisting ? "Update" : "Create";
  const label = `${postType} ${labelType}`;

  const snackbar = useHubSnackBar();
  const getZplString = () => {
    const formData = getValues();
    const props = {
      formData,
      data,
      snackbar,
      returnString: true,
    };
    return handleDownloadZplHelper(props);
  };

  const handleDownloadZPL = () => {
    const formData = getValues();
    const props = {
      formData,
      data,
      snackbar,
    };
    handleDownloadZplHelper(props);
  };

  return (
    <StyledTitleStack>
      <Stack direction="row" gap="10px" alignItems="center">
        <HubBackButton />
        <StyledInput
          name="name"
          defaultValue={name}
          placeholder="No Name"
          disabled={disabled}
          required
        />
      </Stack>
      <Stack direction="row" gap="5px" alignItems="center">
        <HubButton
          variant="contained"
          size="xsmall"
          label="Download ZPL"
          color="neutral"
          onClick={handleDownloadZPL}
        />
        {!batch && (
          <HubButton
            variant="contained"
            size="xsmall"
            label={label}
            type="submit"
          />
        )}
        <BarcodeContextMenu id={id} test={!batch} getZplString={getZplString} />
      </Stack>
    </StyledTitleStack>
  );
};

export default BarcodeBuilderBar;
